import React, {useEffect, useState} from 'react';
import { Modal, Button, Form, Row, Col, Card, Table, Badge, Dropdown, Pagination,  } from 'react-bootstrap';
import {useNavigate} from "react-router-dom";
import FormControl from "../../../shared/components/FormControl";
import {businessYearService} from "../../../services/businessYearService";
import eventEmitter from "../../../shared/eventEmitter";
import {EventEmitterTypes} from "../../../shared/eventEmitterEnum";
import notificationService from "../../../services/NotificationService";
import NotificationService from "../../../services/NotificationService";

interface PricePerSqFtModalProps {
    details?: PriceBracket;
    year: number;
    show: boolean;
    toggle: () => void;
}

interface PriceBracket {
    priceBracketId: number;
    propertyType: string;
    minimumSquareFeet: number;
    maximumSquareFeet: number;
    fixedPrice: number;
    pricePerSquareFoot: number;
}


const PricePerSqFtModal: React.FC<PricePerSqFtModalProps> = ({details, year, show, toggle}) => {
    const [propertyType, setPropertyType] = useState<string>(details?.propertyType || '');
    const [bracketId, setBracketId] = useState<number>(null);
    const [minimumSquareFeet, setMinimumSquareFeet] = useState<number>(details?.minimumSquareFeet || null);
    const [maximumSquareFeet, setMaximumSquareFeet] = useState<number>(details?.maximumSquareFeet || null);
    const [fixedPrice, setFixedPrice] = useState<number>(details?.fixedPrice || null);
    const [pricePerSquareFoot, setPricePerSquareFoot] = useState<number>(details?.pricePerSquareFoot || null);
    const [priceType, setPriceType] = useState('PerSqFt');
    const [showErrors, setShowErrors] = useState(false);

    function handleSave() {
        if(!minimumSquareFeet || !pricePerSquareFoot || !propertyType || propertyType === ''){
            setShowErrors(true);
            return;
        }
        if (bracketId) {
            const postData = {
                priceBracketId: bracketId,
                propertyType: propertyType,
                minimumSquareFeet: minimumSquareFeet,
                maximumSquareFeet: maximumSquareFeet,
                fixedPrice: priceType === 'Fixed' ? fixedPrice : null,
                pricePerSquareFoot: priceType === 'PerSqFt' ? pricePerSquareFoot : null
            }
            businessYearService.updatePriceBracket(postData, year).then(r => {
                eventEmitter.emit(EventEmitterTypes.REFRESH_LOADED_YEAR_PRICE_BRACKET);
                toggle();
            })
        } else {
            const postData = {
                propertyType: propertyType,
                minimumSquareFeet: minimumSquareFeet,
                maximumSquareFeet: maximumSquareFeet,
                fixedPrice: priceType === 'Fixed' ? fixedPrice : null,
                pricePerSquareFoot: priceType === 'PerSqFt' ? pricePerSquareFoot : null
            }
            businessYearService.createPriceBracket(postData, year).then(r => {
                eventEmitter.emit(EventEmitterTypes.REFRESH_LOADED_YEAR_PRICE_BRACKET);
                toggle();
            })
        }
        
    }
    useEffect(() => {
        if(details){
            setPropertyType(details.propertyType);
            setMinimumSquareFeet(details.minimumSquareFeet);
            setMaximumSquareFeet(details.maximumSquareFeet);
            setFixedPrice(details.fixedPrice);
            setPricePerSquareFoot(details.pricePerSquareFoot);
            setBracketId(details.priceBracketId)
            if(details.fixedPrice)
                setPriceType('Fixed')
            else if(details.pricePerSquareFoot)
                setPriceType('PerSqFt')
            else
                setPriceType('')
        } else {
            setPropertyType(null);
            setBracketId(null)
            setMinimumSquareFeet(null);
            setMaximumSquareFeet(null);
            setFixedPrice(null);
            setPricePerSquareFoot(null);
            setPriceType('PerSqFt')
        }
        
    }, [details]);
    
    function handlePriceChange(price: number) {
        if(priceType === 'Fixed') setFixedPrice(price)
        else setPricePerSquareFoot(price)
    }

    return (
        <Modal show={show} onHide={toggle}>
            <Modal.Header closeButton>
                <h5 className="modal-title" id="profileModalTitle">Price Per Sq Ft</h5>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <div className="row gx-3">
                        <Form.Group controlId="propertyType" className="col-md-6 mb-3">
                            <FormControl
                                label="Property Type"
                                required
                                value={propertyType}
                                onChange={(e) => setPropertyType(e.target.value)}
                                showErrors={showErrors}
                                options={[
                                    { value: '', label: 'Select' },
                                    { value: 'Residential', label: 'Residential' },
                                    { value: 'Commercial', label: 'Commercial' },
                                ]}
                            />
                                
                        </Form.Group>
                    </div>
                    <div className="row gx-3">
                        <Form.Group controlId="minimumSquareFeet" className="col-md-6 mb-3">
                            <FormControl
                                type="number"
                                label={"Minimum Square Feet"}
                                value={minimumSquareFeet}
                                showErrors={showErrors}
                                onChange={(e) => setMinimumSquareFeet(parseFloat(e.target.value))}
                                required
                            />
                        </Form.Group>

                        <Form.Group controlId="maximumSquareFeet" className="col-md-6 mb-3">
                            <FormControl
                                type="number"
                                label={"Maximum Square Feet"}
                                value={maximumSquareFeet}
                                showErrors={showErrors}
                                onChange={(e) => setMaximumSquareFeet(parseFloat(e.target.value))}
                            />
                        </Form.Group>
                    </div>
                    <div className="row gx-3">
                        {false && <Form.Group controlId="isFixedPrice" className="col-md-6 mb-3">
                            <Form.Label>Price Type<sup className="text-danger">*</sup></Form.Label>
                            <Form.Select
                                aria-label="isFixedPrice"
                                value={priceType}
                                onChange={(e) => setPriceType(e.target.value)}
                                required
                            >
                                <option value="">Select</option>
                                <option value="Fixed">Fixed Price</option>
                                <option value="PerSqFt">Price Per Sq Ft</option>
                            </Form.Select>
                            {showErrors && propertyType === '' &&
                                <div className="invalid-feedback">
                                    This field is required.
                                </div>
                            }
                        </Form.Group>}
                        <Form.Group controlId="Price" className="col-md-6 mb-3">
                            <FormControl
                                type="number"
                                label={'Price'}
                                value={priceType === 'Fixed' ? fixedPrice : pricePerSquareFoot}
                                showErrors={showErrors}
                                required
                                onChange={(e) => handlePriceChange(parseFloat(e.target.value))}
                            />
                        </Form.Group>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn btn-primary text-strong text-uppercase m-100" onClick={handleSave}>
                    Save
                </Button>
                <Button className="btn btn-cancel text-strong text-uppercase m-100" onClick={toggle}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
        );
};

export default PricePerSqFtModal;
